'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'arrow-down-to-bracket';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e094';
var svgPathData = 'M377 209L241 345c-9.4 9.4-24.6 9.4-33.9 0L71 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l95 95 0-246.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 246.1 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 344l0 72c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72c0 53-43 96-96 96L96 512c-53 0-96-43-96-96l0-72c0-13.3 10.7-24 24-24s24 10.7 24 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowDownToBracket = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;